import React from 'react';

import { inputPropType } from 'helpers/customPropTypes';

import InputBase from '../form-multi/InputBase';

const InputTextArea = (props) => {
    const field = props.field;
    if (field.value === null) {
        field.value = '';
    }
    return (
        <textarea
            id={field.name}
            maxLength={props.setMaxLength && field.maxLength ? field.maxLength : ''}
            name={field.canonicalPath ? field.canonicalPath : field.name}
            value={field.value || ''}
            type={field.type}
            className={props.isNewInput ? null : 'field field-duo'}
            autoComplete="off"
            rows={5}
            cols={1}
            autoFocus={props.focus}
            onFocus={props.onFocus}
            onChange={props.onChange}
            onBlur={props.onBlur}
        />
    );
};

InputTextArea.propTypes = inputPropType(['text', 'textarea']);

export default InputBase(InputTextArea);
